import { useState, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus, faXmark, faRotateRight } from '@fortawesome/free-solid-svg-icons';

import style from './CounterSingle.module.css';

import soundEffect from './assets/increase2.mp3';

const CounterSingle = (props) => {
  const counterStep = 1;

  const [startingCountEdit, setStartingCountEdit] = useState(true);
  const count = props.startingCount;

  const [nameEdit, setNameEdit] = useState(true);
  const [counterName, setCounterName] = useState(props.name);

  // Last click timestamp
  const [lastClickTime, setLastClickTime] = useState(null);
  const [elapsedTimeString, setElapsedTimeString] = useState(''); // for display

  // Update elapsed time every second
  useEffect(() => {
    if (!lastClickTime) return;

    const interval = setInterval(() => {
      const now = Date.now();
      const diff = Math.floor((now - lastClickTime) / 1000); // diff in seconds

      let display = '';
      if (diff < 60) {
        display = `${diff} sec`;
      } else if (diff < 3600) {
        display = `${Math.floor(diff / 60)} min`;
      } else if (diff < 86400) {
        display = `${Math.floor(diff / 3600)} hour${Math.floor(diff / 3600) > 1 ? 's' : ''}`;
      } else {
        display = `${Math.floor(diff / 86400)} day${Math.floor(diff / 86400) > 1 ? 's' : ''}`;
      }

      setElapsedTimeString(display);
    }, 1000);

    return () => clearInterval(interval);
  }, [lastClickTime]);

  const decrementCountHandler = () => {
    playDeviceEffect();
    const newCount = count - counterStep;
    props.countChange(props.itemId, newCount);
    setLastClickTime(Date.now()); // update last click time
  };

  const incrementCounterHandler = () => {
    playDeviceEffect();
    const newCount = count + counterStep;
    props.countChange(props.itemId, newCount);
    triggerHighlightEffect();
    setLastClickTime(Date.now()); // update last click time
  };

  const playDeviceEffect = () => {
    if (props.enableSound) {
      const audio = new Audio(soundEffect);
      audio.currentTime = 0;
      audio.play();
    }
  };

  const triggerHighlightEffect = () => {
    const input = document.getElementById(`counter-input-${props.itemId}`);
    if (!input) return;

    input.style.transition = 'none';
    input.style.backgroundColor = 'limegreen';

    setTimeout(() => {
      input.style.transition = 'background-color 10s linear';
      input.style.backgroundColor = '';
    }, 50);
  };

  const resetCounterHandler = () => {
    if (window.confirm(`Are you sure to RESET counter "${counterName}"?`)) {
      props.countChange(props.itemId, 0);
      setLastClickTime(null); 
      setElapsedTimeString('');
    }
  };

  const removeCounterHandler = () => {
    if (window.confirm(`Are you sure to REMOVE counter "${counterName}"?`)) {
      props.removeItem(props.itemId);
    }
  };

  const enableNameEditHandler = () => setNameEdit(false);

  const disableNameEditHandler = (e) => {
    setNameEdit(true);

    if (e.target.value.trim() === '') {
      setCounterName(props.name);
      props.nameChange(props.itemId, props.name);
    } else {
      props.nameChange(props.itemId, e.target.value.trim());
    }
  };

  const nameEditHandler = (e) => setCounterName(e.target.value);

  const enableStartingCountEditHandler = () => setStartingCountEdit(false);

  const disableStartingCountEditHandler = (e) => {
    setStartingCountEdit(true);
    props.countChange(props.itemId, +e.target.value);
    e.target.value = +e.target.value;
  };

  const startingCountEditHandler = (e) => {
    props.countChange(props.itemId, +e.target.value);
  };

  return (
    <div className={`${style.card} ${style.counter}`}>
      <div style={{ textAlign: 'right' }}>
        <button
          className={`${style['counter__close']} button button-gray button-xs button-icon_only`}
          onClick={removeCounterHandler}
        >
          <FontAwesomeIcon className="icon" icon={faXmark} />
        </button>
      </div>

      <div className={style['counter__name']}>
        <input
          className={style['counter__name-input']}
          type="text"
          value={counterName}
          readOnly={nameEdit}
          onClick={enableNameEditHandler}
          onBlur={disableNameEditHandler}
          onChange={nameEditHandler}
        />
      </div>

      <div className={style['counter__main']}>
        <div className={style['counter__main-column']}>
          <button
            type="button"
            className="button button-primary button-icon_only"
            title="Count Down"
            onClick={decrementCountHandler}
          >
            <FontAwesomeIcon className="icon" icon={faMinus} />
          </button>
        </div>
        <div
          className={`${style['counter__main-column']} ${style['counter__main-output']}`}
        >
          <input
            id={`counter-input-${props.itemId}`}
            className={style['counter__output-input']}
            type="number"
            value={count}
            readOnly={startingCountEdit}
            onClick={enableStartingCountEditHandler}
            onBlur={disableStartingCountEditHandler}
            onChange={startingCountEditHandler}
            style={{
              transition: 'background-color 10s ease'
            }}
          />
        </div>
        <div className={style['counter__main-column']}>
          <button
            type="button"
            className="button button-primary button-icon_only"
            title="Count Up"
            onClick={incrementCounterHandler}
          >
            <FontAwesomeIcon className="icon" icon={faPlus} />
          </button>
        </div>
      </div>

      <div className={style['counter__actions']}>
        <div className={style['counter__actions-reset-content']}>
          <button
            className="button button-white button-xs button-icon_only"
            title="Reset"
            onClick={resetCounterHandler}
          >
            <FontAwesomeIcon className="icon" icon={faRotateRight} />
          </button>
          {
            elapsedTimeString && (
              <span className={style['counter__action_elapsed']}>{elapsedTimeString}</span>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default CounterSingle;